<script>
  import SlideUpDown from 'vue-slide-up-down'

  /**
   * A component to wrap nodes with in order to show/hide them by making them slide down/up (like jQuery's `slideDown()` and `slideUp()`) while fading in/out and slightly zooming in/out.
   */
  export default {
    components: {
      SlideUpDown,
    },
    props: {
      /** Whether the content is currently expanded (visible). */
      expanded: {
        type: Boolean,
        default: false,
      },
    },
    mounted() {
      this.removeInvalidAria()
    },
    updated() {
      this.removeInvalidAria()
    },
    methods: {
      // vue-slide-up-down renders aria-expanded on a plain <div>, which is invalid ARIA
      // (aria-expanded is only allowed on interactive roles). Remove it so screen readers
      // don't encounter an invalid attribute — the controlling button already carries it.
      removeInvalidAria() {
        const el = this.$el && this.$el.querySelector('.slide-up-down-component')
        if (el) el.removeAttribute('aria-expanded')
      },
    },
  }
</script>

<template>
  <transition name="slide-up-down">
    <div v-show="expanded" class="transform transition">
      <SlideUpDown :active="expanded" class="slide-up-down-component">
        <!-- @slot The content to show/hide. -->
        <slot />
      </SlideUpDown>
    </div>
  </transition>
</template>

<style lang="postcss" scoped>
  .slide-up-down {
    &-enter-active {
      transition-delay: 50ms;
      transition-duration: 200ms;
    }

    &-leave-active {
      transition-duration: 250ms;
    }

    &-enter,
    &-leave-to {
      @apply opacity-0 scale-95;
    }

    &-component {
      overflow: visible !important;
      transition-duration: 200ms !important;

      .slide-up-down-leave-active & {
        transition-delay: 50ms;
      }
    }
  }
</style>
